import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/fold2/BgImg03.webp";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>Experienced Mobile App Developers in Los Angeles</h2>
            </div>
            <p>
              Tekrevol has positioned itself as a full-service digital
              transformation and business automation company that not only has
              the best app developers in Los Angeles but a complete incubation
              team comprising product strategists, business analysts, and
              transformation consultants.
            </p>
            <p>
              As part of our mission to make a difference, we have developed
              some amazing and innovative technological solutions including
              mobile applications, blockchain wallets, ML-based route management
              systems, and more!
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
